<template>
  <el-container class="adverse-reaction">
    <div class="headerCom">
      <publicBreadCrumb :breadList="breadList" />
      <publicExpandSearch padBottom='0px' :searchList='searchList' :rightEventList="rightEventList" @rightFunc='rightFunc'
        v-on:getSearchObj='getSearchObj' :setRightWidth='true'>
      </publicExpandSearch>
    </div>
    <el-main class="listTabel">
      <el-table :data="tableData" :max-height="750" :header-cell-style="{
          background: '#FAFAFA',  fontWeight: 'bold', color: '#333333', fontSize: '14px'}">
        <el-table-column type="index" label="序号"> </el-table-column>
        <el-table-column align="center" show-overflow-tooltip prop="diseaseTypeName" label="对应病种">
        </el-table-column>
        <el-table-column align="center" prop="diseaseStageName" label="对应阶段" min-width="100px" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="tooltipWidth">{{ scope.row.diseaseStageName | filterValgang }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="firstCategoryName" label="不良反应大类" min-width="100px" show-overflow-tooltip align="center">
          <template slot-scope="scope">
            <span class="tooltipWidth">{{ scope.row.firstCategoryName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="oldName" align="center" label="不良反应小类" min-width="100px" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="tooltipWidth">{{ scope.row.secondCategoryName  }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" show-overflow-tooltip align="center" label="不良反应名称" min-width="100px">
          <template slot-scope="scope">
            <span class="tooltipWidth">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="referenceName" label="参考现象" min-width="100px" show-overflow-tooltip align="center">
          <template slot-scope="scope">
            <span class="tooltipWidth">{{ scope.row.referenceName | filterValgang}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip prop="terminologyName" label="对应术语">
          <template slot-scope="scope">
            <span class="tooltipWidth">{{ scope.row.terminologyName | filterValgang}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip prop="referenceRange" label="参考范围">
          <template slot-scope="scope">
            <span class="tooltipWidth">{{ scope.row.referenceRange | filterValgang}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip prop="referenceUnit" label="对应单位">
          <template slot-scope="scope">
            <span class="tooltipWidth">{{ scope.row.referenceUnit | filterValgang}}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" fixed="right" width="180" label="操作">
          <template slot-scope="scope">
            <el-button @click="onDetailsClick(scope.row)" type="text" size="small">
              详情
            </el-button>
            <el-button @click="onEditeClick(scope.row)" type="text" size="small">
              修改
            </el-button>
            <!-- <el-button
              @click="onStatusClick(scope.row)"
              type="text"
              size="small"
            >
              {{ scope.row.status ? "启用" : "停用" }}
            </el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="searchParams.current" :page-size="searchParams.size"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-main>
    <el-dialog title="新增不良反应类别" width="700px" :close-on-press-escape="false" :close-on-click-modal="false"
      v-if="dialogHisRecords" :visible.sync="dialogHisRecords" center @close="handleClose">
      <el-form :model="HisForm" ref="hisForm" :rules="hisRules" label-width="130px" size="small">
        <el-form-item label="对应病种：" prop="diseaseTypeId">
          <el-select filterable style="width:90%" @change="diseaseTypeChange" v-model="HisForm.diseaseTypeId"
            placeholder="请选择对应病种">
            <el-option v-for="item in diseaseTypeList" :key="item.value" :label="item.suborderName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="对应阶段：" prop="diseaseStageId">
          <el-select filterable style="width:90%" :disabled="!HisForm.diseaseTypeId" v-model="HisForm.diseaseStageId"
            @change="diseaseStageChange" placeholder="请选择对应阶段">
            <el-option v-for="item in diseaseStageList" :key="item.value" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类名称：" prop="categoryName">
          <el-input type="textarea" show-word-limit style="width:90%" v-model="HisForm.categoryName" maxlength="30"
            :autosize="{ minRows: 3, maxRows: 4}" placeholder="请输入分类名称" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="上级分类：" prop="parentId">
          <el-select filterable style="width:90%" v-model="HisForm.parentId" :disabled="!HisForm.diseaseStageId"
            placeholder="请选择上级分类">
            <el-option v-for="item in parentList1" :key="item.value" :label="item.categoryName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注：" prop="remark">
          <el-input type="textarea" style="width:90%" placeholder="请输入您要备注的内容" show-word-limit v-model="HisForm.remark"
            maxlength="200" :autosize="{ minRows: 5, maxRows: 10}" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">重置</el-button>
        <el-button size="small" type="primary" @click="HisFormSure">确 定</el-button>
      </div>
    </el-dialog>

    <el-drawer size="700px" :show-close="false" :close-on-press-escape="false" :visible.sync="dialogAdd"
      v-if="dialogAdd" direction="rtl" :before-close="handleClose1">
      <h1 style="margin:14px auto 40px;font-size: 22px;font-weight:bold;text-align:center">新增不良反应项目</h1>
      <el-form :model="AddForm" ref="AddForm" :rules="addRules" label-width="170px" size="small">
        <el-form-item label="不良反应类别大类：" prop="firstCategoryId">
          <el-row>
            <el-col :span="20">
              <el-select filterable v-model="AddForm.firstCategoryId" placeholder="请选择不良反应类别大类"
                @change="firstCategoryIdChange">
                <el-option v-for="item in parentList" :key="item.value" :label="item.categoryName" :value="item.id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="不良反应类别小类：" prop="secondCategoryId">
          <el-row>
            <el-col :span="20">
              <el-select :disabled="!AddForm.firstCategoryId" filterable v-model="AddForm.secondCategoryId"
                placeholder="请选择不良反应类别小类">
                <el-option v-for="item in secondCategoryList" :key="item.value"
                  :label="item.categoryName?item.categoryName:'空'" :value="item.id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="不良反应项目全称：" prop="name">
          <el-row>
            <el-col :span="20">
              <el-input v-model="AddForm.name" maxlength="50" type="textarea" show-word-limit placeholder="请输入不良反应项目全称"
                autocomplete="off"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <div v-for="(item, i) in AddForm.adverseReactionPhenomenonList" :key="i">
          <el-form-item :key="i" :label="i > 0 ? '参考现象' + (i + 1) + '：' : '参考现象：'" :rules="{
              required: true,
              message: '该项为必填项',
              trigger: 'blur'
            }">
            <el-row>
              <el-col :span="20">
                <el-input style="margin-right:10px" v-model="item.referenceName" maxlength="50" show-word-limit
                  :autosize="{ minRows: 3, maxRows: 4}" type="textarea" placeholder="请输入参考现象"></el-input>
              </el-col>
              <el-col :span="4" v-if="i > 0">
                <img @click="deleteAdverseReactionPhenomenonList(i)"
                  style="width:23px;height:23px;vertical-align:middle;margin-left:20px;cursor:pointer"
                  src="@/assets/images/jianDelete.png" alt="" />
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item :label="i > 0 ? '对应术语' + (i + 1) + '：' : '对应术语：'" prop="terminologyId">

            <el-row>
              <el-col :span="20">
                <div class="rightBtn treebox-contain">
                  <el-input v-model="item.terminologyName" placeholder="请选择对应术语"
                    @focus.stop="treeboxShowIndex(i)" @click.native.stop="treeboxShowIndex(i)"
                    @keyup.native="treeKeySearchIndex(i)">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                  </el-input>
                  <div class="treebox-center" v-if="item.dialogVisible">
                    <div class="treebox" @click.stop="treeboxShowIndex(i)" v-if="item.terminologyName.length <= 0">
                      <box-tree-add :pagec="pagec" :ld="ld" :treeitem="treeitems" :editl="editl"
                        :proplist="lists"></box-tree-add>
                    </div>

                    <!-- <tree-search
                      v-if="
                        item.dialogVisible &&
                          searchDataList &&
                          searchDataList.length > 0 &&
                          item.terminologyName.length > 0
                      "
                      @changePage="onChange"
                      @treeboxShow="treeboxShow(i)"
                      @selectClick="selectClick(i)"
                      :searchDataList="searchDataList"
                      :paramsList="paramsList"
                      :total="total"
                      :index="i"
                    >
                    </tree-search> -->
                    <!-- @click.stop="treeboxShowIndex(i)" -->
                    <div class="treebox-list" v-if="
                        item.dialogVisible &&
                          searchDataList &&
                          searchDataList.length > 0 &&
                          item.terminologyName.length > 0  ">
                      <div class="treebox-list-item" v-for="(items, index) in searchDataList" :key="index">
                        <div class="treebox-list-item-title">
                          {{ items.name }}
                        </div>
                        <span class="select-btn" @click="selectClickIndex(items, i)">添加</span>
                      </div>
                      <div class="mt20" v-if="total > 10">
                        <el-pagination v-model="paramsList.current" :total="total" size="small"
                          :page-size="paramsList.size" @current-change="onChange">
                        </el-pagination>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item :label="i > 0 ? '参考范围值' + (i + 1) + '：' : '参考范围值：'" prop="referenceSign">
            <el-row>
              <el-col :span="5">
                <el-select v-model="item.referenceSign" clearable placeholder="请选择">
                  <el-option v-for="item in determineArr" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="10">
                <el-input style="width: calc(100% - 16px);margin:0 8px" v-model="item.referenceValue"
                  placeholder="手输数值0~999.99" autocomplete="off"></el-input>
              </el-col>
              <el-col :span="5">
                <el-select v-model="item.referenceUnit" clearable placeholder="请选择">
                  <el-option v-for="item in qualitative" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item :key="i + 1" :label="i > 0 ? '处理措施' + (i + 1) + '：' : '处理措施：'" :rules="{
              required: true,
              message: '该项为必填项',
              trigger: 'blur'
            }">
            <el-row>
              <el-col :span="20">
                <el-input type="textarea" maxlength="500" show-word-limit :autosize="{minRows:5,maxRows:10}"
                  v-model="item.measure" placeholder="请输入处理措施"></el-input>
              </el-col>
            </el-row>
          </el-form-item>
        </div>
        <el-form-item>
          <el-row>
            <el-col :span="20">
              <div class="add-btn-box" @click="addAdverseReactionPhenomenonList">
                + 添加一条参考现象
              </div>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-row>
            <el-col :span="20" style="text-align:center">
              <el-button @click="resetForm">重置</el-button>
              <el-button type="primary" @click="addFormSure">确 定</el-button>
            </el-col>
          </el-row>

        </el-form-item>
      </el-form>
    </el-drawer>
    <el-dialog title="不良反应项目详情" width="700px" :close-on-press-escape="false" :close-on-click-modal="false"
      v-if="checkDialog" :visible.sync="checkDialog" center>
      <el-form :model="checkForm" label-width="150px">
        <el-form-item label="不良反应类别大类：">
          {{ checkForm.firstCategoryName }}
        </el-form-item>
        <el-form-item label="不良反应类别小类：">
          {{ checkForm.secondCategoryName }}
        </el-form-item>
        <el-form-item label="不良反应项目全称：">
          <div style="overflow-wrap: break-word;">{{ checkForm.name }}</div>
        </el-form-item>
        <el-form-item label="参考现象：">
          <div style="overflow-wrap: break-word;">{{ checkForm.referenceName }}</div>
        </el-form-item>
        <el-form-item label="对应术语：">
          {{ checkForm.terminologyName }}
        </el-form-item>
        <el-form-item label="参考值范围：">
          {{
            checkForm.referenceSign +
              checkForm.referenceValue +
              checkForm.referenceUnit
          }}
        </el-form-item>
        <el-form-item label="处理措施：">
          <div style="overflow-wrap: break-word;">{{ checkForm.measure }}</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="checkDialog = false">确 定</el-button>
      </div>
    </el-dialog>
    <el-drawer size="700px" :show-close="false" :close-on-press-escape="false" :visible.sync="dialogEdit"
      v-if="dialogEdit" :before-close="handleClose2" direction="rtl">
      <h1 style="margin:14px auto 40px;font-size: 22px;font-weight:bold;text-align:center">编辑不良反应</h1>
      <el-form :model="checkForm" ref="checkForm" :rules="editRules" label-width="170px" size="small">
        <el-form-item label="不良反应类别大类：" prop="firstCategoryId">
          <el-row>
            <el-col :span="22">
              <el-select filterable v-model="checkForm.firstCategoryId" placeholder="请选择不良反应类别大类"
                @change="remotesecondCategory1">
                <el-option v-for="item in parentList" :key="item.value" :label="item.categoryName" :value="item.id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="不良反应类别小类：" prop="secondCategoryId">
          <el-row>
            <el-col :span="22">
              <el-select :disabled="!checkForm.firstCategoryId" filterable v-model="checkForm.secondCategoryId"
                placeholder="请选择不良反应类别小类">
                <el-option v-for="item in secondCategoryList" :key="item.value"
                  :label="item.categoryName?item.categoryName:'空'" :value="item.id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="不良反应项目全称：" prop="name">
          <el-row>
            <el-col :span="22">
              <el-input v-model="checkForm.name" maxlength="50" type="textarea" show-word-limit
                placeholder="请输入不良反应项目全称" autocomplete="off"></el-input>
            </el-col>
          </el-row>
        </el-form-item> 
        <el-form-item label="参考现象：" prop="referenceName">
          <el-row>
            <el-col :span="22">
              <el-input style="margin-right:10px" v-model="checkForm.referenceName" maxlength="50" show-word-limit
                type="textarea" placeholder="请输入参考现象"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="'对应术语：'" prop="terminologyId">
          <el-row>
            <el-col :span="22">
              <div class="rightBtn treebox-contain">
                <el-input v-model="checkForm.terminologyName" placeholder="请选择对应术语"
                  @focus.stop="treeboxShow" @click.native.stop="treeboxShow" @keyup.native="treeKeySearch">
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <div class="treebox-centers" v-if="dialogVisible">
                  <div class="treebox" @click.stop="treeboxShow" v-if="checkForm.terminologyName.length <= 0">
                    <box-tree-add :pagec="pagec" :ld="ld" :treeitem="treeitems" :editl="editl"
                      :proplist="lists"></box-tree-add>
                  </div> 
                  <!-- <tree-search
                  v-if="
                    dialogVisible &&
                      searchDataList &&
                      searchDataList.length > 0 &&
                      searchParamsTitle.length > 0
                  "
                  @changePage="onChange"
                  @treeboxShow="treeboxShow"
                  @selectClick="selectClick"
                  :searchDataList="searchDataList"
                  :paramsList="paramsList"
                  :total="total"
                >
                </tree-search> -->
                  <!-- @click.stop="treeboxShow" -->
                  <div class="treebox-list" v-if="
                    dialogVisible &&
                      searchDataList &&
                      searchDataList.length > 0 &&
                      checkForm.terminologyName.length > 0 ">
                    <div class="treebox-list-item" v-for="(items, index) in searchDataList" :key="index">
                      <div class="treebox-list-item-title">
                        {{ items.name }}
                      </div>
                      <span class="select-btn" @click="selectClick(items)">添加</span>
                    </div>
                    <div class="mt20" v-if="total > 10">
                      <el-pagination v-model="paramsList.current" :total="total" size="small"
                        :page-size="paramsList.size" @current-change="onChange">
                      </el-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="'参考范围值：'" prop="referenceSign">
          <el-row>
            <el-col :span="6">
              <el-select v-model="checkForm.referenceSign" clearable placeholder="请选择">
                <el-option v-for="item in determineArr" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="10">
              <el-input style="width: calc(100% - 16px);margin:0 8px" v-model="checkForm.referenceValue"
                placeholder="手输数值0~999.99" autocomplete="off"></el-input>
            </el-col>
            <el-col :span="6">
              <el-select v-model="checkForm.referenceUnit" clearable placeholder="请选择">
                <el-option v-for="item in qualitative" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="'处理措施：'" prop="measure">
          <el-row>
            <el-col :span="22">
              <el-input type="textarea" maxlength="500" show-word-limit :autosize="{ minRows: 5, maxRows: 10}"
                v-model="checkForm.measure" placeholder="请输入处理措施"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <!-- </div> -->
        <el-form-item>
          <div style="text-align:center">
            <el-button type="primary" @click="editFormSure">确 定</el-button>
          </div>
        </el-form-item>
      </el-form> 
    </el-drawer> 
  </el-container>
</template> 
<script>
import "@/utils/elAdd.js";
import {
  adverseReactionPage,
  adverseReactionCategory,
  findIcdDiseaseByCondition,
  adverseReactionStage,
  adverseReactionCategoryInsertReturnId,
  DiseaseType,
  adverseReactionPhenomenon,
  adverseReactionAdd,
  getInfoByAdverseReactionPhenomenonId,
  PutAdverseReactionPhenomenonId,
  getTerminologyTree
} from "../../api";
import treeSearch from "@/components/treeSearch/treeSearch";

export default {
  data() {
    return {
      searchType: "",
      dialogEdit: false,
      tagList: [],
      breadList: [{ name: "标准数据库" }, { name: "不良反应" }],
      searchParams1: {
        name: "",
        firstCategoryId: "",
        secondCategoryId: "",
        diseaseTypeId: "",
        diseaseStageId: ""
      },
      searchList: [
        {
          label: "不良反应名称",
          value: 1,
          paramName: "name",
          inputType: "input"
        },
        {
          label: "不良反应大类",
          value: 2,
          paramName: "firstCategoryId",
          inputType: "select",
          optionData: []
        },
        {
          label: "不良反应小类",
          value: 3,
          paramName: "secondCategoryId",
          inputType: "select",
          optionData: []
        },
        {
          label: "对应病种",
          value: 4,
          paramName: "diseaseTypeId",
          optionData: [],
          inputType: "select"
        },
        {
          label: "对应阶段",
          value: 5,
          paramName: "diseaseStageId",
          optionData: [],
          inputType: "select"
        }
      ],
      rightEventList: [
        { eventName: "新增不良反应类别", eventValue: 1 },
        { eventName: "新增不良反应项目", eventValue: 2 }
      ],
      searchParams: {
        current: 1,
        size: 10
      }, 
      total: 0,
      tableData: [],
      hisRules: {
        categoryName: [
          { required: true, message: "该项为必填项", trigger: "blur" },
          { min: 1, max: 30, trigger: "blur" }
        ],
        diseaseTypeId: [
          { required: true, message: "该项为必填项", trigger: "change" }
        ],
        diseaseStageId: [
          { required: true, message: "该项为必填项", trigger: "change" }
        ],
        parentId: [
          { required: true, message: "该项为必填项", trigger: "change" }
        ]
      },
      HisForm: {
        diseaseTypeId: "",
        diseaseStageId: "",
        categoryName: "",
        parentId: "",
        remark: ""
      },
      diseaseStageList: [],
      parentList: [],
      parentList1: [],
      dialogHisRecords: false,
      parentId: null,
      regionId: null,
      //测试
      codeLoading: false,
      codePage: {
        current: 1,
        size: 10
      },
      keyWord: "",
      pages: 0,
      mergePage: {
        current: 1,
        size: 10
      },
      mergeName: "",
      mergeNameTotal: "",
      diseaseTypeList: [],
      dialogAdd: false,
      AddForm: {
        name: "",
        adverseReactionPhenomenonList: [
          {
            referenceSign: "",
            referenceUnit: "",
            referenceValue: "",
            referenceName: "",
            terminologyId: "",
            measure: "",
            terminologyName: "",
            dialogVisible: false
          }
        ],
        firstCategoryId: "",
        secondCategoryId: ""
      },
      checkForm: {
        name: "",
        referenceSign: "",
        referenceUnit: "",
        referenceValue: "",
        referenceName: "",
        terminologyId: "",
        measure: "",
        firstCategoryId: "",
        secondCategoryId: "",
        terminologyName: ""
      },
      addRules: {
        name: [{ required: true, message: "该项为必填项", trigger: "blur" }],
        adverseReactionPhenomenonList: [
          { required: true, message: "该项为必填项", trigger: "change" }
        ],
        firstCategoryId: [
          { required: true, message: "该项为必填项", trigger: "change" }
        ],
        secondCategoryId: [
          { required: true, message: "该项为必填项", trigger: "change" }
        ]
      },
      editRules: {
        name: [{ required: true, message: "该项为必填项", trigger: "blur" }],
        adverseReactionPhenomenonList: [
          { required: true, message: "该项为必填项", trigger: "change" }
        ],
        firstCategoryId: [
          { required: true, message: "该项为必填项", trigger: "change" }
        ],
        secondCategoryId: [
          { required: true, message: "该项为必填项", trigger: "change" }
        ],
        referenceName: [
          { required: true, message: "该项为必填项", trigger: "blur" }
        ],
        measure: [{ required: true, message: "该项为必填项", trigger: "blur" }]
      },
      checkDialog: false,
      secondCategoryList: [],
      qualitative: [
        "秒",
        "分",
        "时",
        "日",
        "周",
        "月",
        "年",
        "毫升",
        "升",
        "毫米",
        "厘米",
        "分米",
        "米",
        "千米",
        "mmol/L",
        "岁"
      ],
      determineArr: [
        ">",
        "≥",
        "=",
        "<",
        "≤",
        "≠",
        "+",
        "-",
        "++",
        "--",
        "+-",
        "+++",
        "---",
        "是",
        "否",
        "不确定"
      ], 
      searchDataList: [], //搜索数据
      paramsList: {
        current: 1, //页码
        size: 10, //页数
        name: ""
      },
      total: 0, //总页数
      pageSizeOptions: ["10", "20", "30", "40", "50"],
      current: 1,
      pageSize: 10,
      // 弹出
      dialogVisible: false,
      ld: false,
      dataArrNew: [], //文本框回显的数据
      searchParamsTitle: "",
      dataIndex: -1,
      // 表格编辑数据
      editl: [
        {
          //   icon: "el-icon-view",
          father: "recruit",
          name1: "添加",
          name2: "",
          arrFun: treeObj => {
            let flag = true;
            if (this.dataArrNew.length > 0) {
              for (var i = 0; i < this.dataArrNew.length; i++) {
                if (this.dataArrNew[i].id == treeObj.id) {
                  this.$message.error("已经添加过此术语集，请选择其他术语集");
                  flag = false;
                }
              }
            }
            if (flag) {
              let nameArr = []; 
              this.dataArrNew = [];
              this.dataArrNew.push(treeObj);
              this.dataArrNew.forEach(item => {
                nameArr.push(item.twoLayersName);
              });
              // this.searchParamsTitle = nameArr.toString();
              this.selectTermObj = nameArr[0];
              this.searchParamsTitle = nameArr[0].twoLayersName;
              if (this.dataIndex == -1) {
                this.checkForm.terminologyName = nameArr.toString();
                this.checkForm.terminologyId = treeObj.id;
              } else {
                this.AddForm.adverseReactionPhenomenonList[
                  this.dataIndex
                ].terminologyName = nameArr.toString();
                this.AddForm.adverseReactionPhenomenonList[
                  this.dataIndex
                ].terminologyId = treeObj.id;
              }
            }
          },
          click(item) {
            this.arrFun(item);
          }
        }
      ],
      lists: {
        rowKey: "id",
        labelw: [
          {
            label: "",
            prop: "name"
          }
        ],
        col: {
          top: 1,
          list: []
        }
      },
      disable: false,

      treeList: [],
      defaultProps: {
        value: "Id",
        label: "label",
        children: "children"
      },
      form: {
        Id: "",
        lable: ""
      },

      selVal: "",
      activeName: "first",
      questionItemList: [],
      reactionData: [],

      selectNumList: [],
      selectNumUnit: []
    };
  },
  components: {
    treeSearch
  },
  watch: {},
  filters: {},

  created() {
    this.getList();
    this.getFirstCategoryList();
    this.getSecondCategoryList();
    this.getThirdCategoryList();
    this.getFourCategoryList();
    DiseaseType()
      .then(result => {
        this.diseaseTypeList = result.data;
      })
      .catch(err => {});
    // this.getTermUnitList();
    this.findConceptChildrenRequest();
  },
  methods: { 
    editFormSure() {
      this.$refs["checkForm"].validate(v => {
        if (v) {
          if (!this.checkForm.name.trim()) {
            return this.$message.info("请按要求填写");
          }
          if (!this.checkForm.referenceName.trim()) {
            return this.$message.info("请按要求填写参考现象");
          }
          if (!this.checkForm.measure.trim()) {
            return this.$message.info("请按要求填写处理措施");
          }
          if (
            this.checkForm.referenceValue &&
            !/(^\d+(\.\d+)?$)|(^\d+(\/\d+)?$)/.test(
              this.checkForm.referenceValue
            )
          ) {
            return this.$message.info("请按要求填写参考范围值");
          }
          PutAdverseReactionPhenomenonId(this.checkForm)
            .then(result => {
              this.getList();
              this.$message.success("操作成功");
              this.dialogEdit = false;
            })
            .catch(err => {});
        }
      });
    },
    addFormSure() {
      this.$refs["AddForm"].validate(v => {
        if (v) {
          if (!this.AddForm.name.trim()) {
            return this.$message.info("请按要求填写");
          }
          for (
            let index = 0;
            index < this.AddForm.adverseReactionPhenomenonList.length;
            index++
          ) {
            if (
              !this.AddForm.adverseReactionPhenomenonList[
                index
              ].referenceName.trim()
            ) {
              return this.$message.info("请按要求填写参考现象");
            }
            if (
              !this.AddForm.adverseReactionPhenomenonList[index].measure.trim()
            ) {
              return this.$message.info("请按要求填写处理措施");
            }
            if (
              this.AddForm.adverseReactionPhenomenonList[index]
                .referenceValue &&
              !/(^\d+(\.\d+)?$)|(^\d+(\/\d+)?$)/.test(
                this.AddForm.adverseReactionPhenomenonList[index].referenceValue
              )
            ) {
              return this.$message.info("请按要求填写参考范围值");
            }
          }
          adverseReactionAdd(this.AddForm)
            .then(result => {
              this.$message.success("操作成功");
              this.getList();
              this.handleClose1();
            })
            .catch(err => {});
        }
      });
    },
    addAdverseReactionPhenomenonList() {
      this.AddForm.adverseReactionPhenomenonList.push({
        referenceSign: "",
        referenceUnit: "",
        referenceValue: "",
        referenceName: "",
        terminologyId: "",
        measure: "",
        terminologyName: "",
        dialogVisible: false
      });
      this.dataArrNew = []; //清空数组  下次回显单独数据
      this.findConceptChildrenRequest(); //重新调用树组件方法，初始化
    },
    deleteAdverseReactionPhenomenonList(i) {
      this.AddForm.adverseReactionPhenomenonList.splice(i, 1);
    },
    handleClose() {
      this.parentList1 = []; 
      this.$refs["hisForm"].resetFields(); 
    },
    handleClose1() {
      this.AddForm = this.$options.data().AddForm;
      this.$refs["AddForm"].resetFields();
      this.searchDataList = [];
      this.treeboxHide();
      // this.parentList = [];
      this.secondCategoryList = [];
      this.dialogAdd = false;
    },
    handleClose2() {
      this.treeboxHide();
      this.searchDataList = [];
      this.dialogEdit = false;
    }, 
    HisFormSure() {
      this.$refs["hisForm"].validate(v => {
        if (v) {
          if (!this.HisForm.categoryName.trim()) {
            return this.$message.info("请按要求填写");
          }
          adverseReactionCategoryInsertReturnId(this.HisForm)
            .then(result => {
              this.$message.success("操作成功");
              this.dialogHisRecords = false;
              this.HisForm = this.$options.data().HisForm;
            })
            .catch(err => {});
        }
      });
    },
    diseaseStageChange() {
      this.HisForm.parentId = "";
      adverseReactionCategory({
        diseaseTypeId: this.HisForm.diseaseTypeId,
        diseaseStageId: this.HisForm.diseaseStageId,
        parentId: 0,
        status: 0,
        categoryName: ""
      })
        .then(result => {
          this.parentList1 = result.data;
        })
        .catch(err => {});
    },
    diseaseTypeChange() {
      this.HisForm.diseaseStageId = "";
      this.HisForm.parentId = "";
      adverseReactionStage({
        diseaseTypeId: this.HisForm.diseaseTypeId,
        status: 0 
      })
        .then(result => {
          this.diseaseStageList = result.data;
        })
        .catch(err => {});
    },
    firstCategoryIdChange() {
      this.AddForm.secondCategoryId = "";
      adverseReactionCategory({
        parentId: this.AddForm.firstCategoryId,
        status: 0,
        categoryName: ""
      })
        .then(result => {
          this.secondCategoryList = result.data;
        })
        .catch(err => {});
    },
    remotesecondCategory1(query) {
      this.checkForm.secondCategoryId = "";
      adverseReactionCategory({
        parentId: this.checkForm.firstCategoryId,
        status: 0,
        categoryName: ""
      })
        .then(result => {
          this.secondCategoryList = result.data;
        })
        .catch(err => {});
    },
    getFirstCategoryList() {
      adverseReactionCategory({
        parentId: 0,
        status: 0,
        categoryName: ""
      })
        .then(result => {
          this.parentList = result.data;
          this.searchList[1].optionData = result.data.map(item => {
            return {
              ...item,
              value: item.id,
              label: item.categoryName
            };
          });
        })
        .catch(err => {});
    },
    getSecondCategoryList(query) {
      adverseReactionCategory({
        parentId: this.searchParams.firstCategoryId
          ? this.searchParams.firstCategoryId
          : "",
        status: 0,
        categoryName: ""
      })
        .then(result => {
          this.searchList[2].optionData = result.data.map(item => {
            return {
              ...item,
              value: item.id,
              label: item.categoryName
            };
          });
        })
        .catch(err => {});
    },
    getThirdCategoryList(query) {
      findIcdDiseaseByCondition({
        conditionName: query
      })
        .then(result => {
          this.searchList[3].optionData = result.data.map(item => {
            return {
              ...item,
              value: item.id,
              label: item.suborderName
            };
          });
        })
        .catch(err => {});
    },
    getFourCategoryList(query) {
      adverseReactionStage({
        status: 0,
        name: query
      })
        .then(result => {
          this.searchList[4].optionData = result.data.map(item => {
            return {
              ...item,
              value: item.id,
              label: item.name
            };
          });
        })
        .catch(err => {});
    }, 
    getSearchObj(obj) {
      //清空之前合并过的条件
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...obj, ...this.searchParams };
      this.getList();
    }, 
    onDetailsClick(row) {
      this.checkDialog = true;
      this.getDetails(row.adverseReactionPhenomenonId);
    },
    onEditeClick(row) {
      this.dialogEdit = true;
      this.getDetails(row.adverseReactionPhenomenonId);
    },
    onStatusClick(data) {
      adverseReactionPhenomenon({
        adverseReactionPhenomenonId: data.adverseReactionPhenomenonId,
        status: !data.status
      })
        .then(result => {
          this.$message.success("操作成功");
          this.getList();
        })
        .catch(err => {});
    }, 
    getList() {
      adverseReactionPage({ ...this.searchParams }).then(res => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      });
    }, 
    getDetails(id) {
      getInfoByAdverseReactionPhenomenonId({ adverseReactionPhenomenonId: id })
        .then(result => {
          this.checkForm = result.data;
          if (!result.data.terminologyName) {
            this.checkForm.terminologyName = "";
          }
          adverseReactionCategory({
            parentId: result.data.firstCategoryId,
            status: 0,
            categoryName: ""
          })
            .then(res => {
              this.secondCategoryList = res.data;
            })
            .catch(err => {});
        })
        .catch(err => {});
    }, 
    resetForm(formName) {
      this.$refs["AddForm"].resetFields();
      this.AddForm = this.$options.data().AddForm;
    }, 
    handleSizeChange(value) {
      this.searchParams.size = value;
      this.getList();
    },
    handleCurrentChange(value) {
      this.searchParams.current = value;
      this.getList();
    }, 
    treeKeySearch() {
      //  文本框只搜索搜索
      this.dataIndex = -1;
      this.dataArrNew = [];
      //文本框输入搜索
      if (this.checkForm.terminologyName.length > 1) {
        this.dialogVisible = true;
        this.findConceptByTitleRequest();
      } else {
        this.searchDataList = [];
        this.paramsList.current = 1;
      }
    },
    treeKeySearchIndex(i) {
      //  文本框只搜索搜索
      this.dataIndex = i;
      this.dataArrNew = [];
      //文本框输入搜索
      if (
        this.AddForm.adverseReactionPhenomenonList[i].terminologyName.length > 1
      ) {
        this.AddForm.adverseReactionPhenomenonList[i].dialogVisible = true;
        this.findConceptByTitleRequest(true, i);
      } else {
        this.searchDataList = [];
        this.paramsList.current = 1;
      }
    },
    treeboxShow() {
      this.dataIndex = -1;
      this.dialogVisible = true;
    },
    treeboxShowIndex(i) {
      this.dataIndex = i;
      for (
        let index = 0;
        index < this.AddForm.adverseReactionPhenomenonList.length;
        index++
      ) {
        this.AddForm.adverseReactionPhenomenonList[index].dialogVisible = false;
      }
      this.AddForm.adverseReactionPhenomenonList[i].dialogVisible = true;
    }, 
    selectClick(treeObj) {
      //搜索节点添加
      let flag = true;
      if (this.dataArrNew.length > 0) {
        for (var i = 0; i < this.dataArrNew.length; i++) {
          if (this.dataArrNew[i].id == treeObj.id) {
            this.$message.error("已经添加过此术语集，请选择其他术语集");
            flag = false;
          }
        }
      }
      if (flag) {
        let nameArr = [];
        this.dataArrNew.push(treeObj);
        this.dataArrNew.forEach(item => {
          nameArr.push(item.twoLayersName);
        });
        this.checkForm.terminologyName = nameArr.toString();
        this.checkForm.terminologyId = treeObj.id;
        this.dialogVisible = false;
        this.searchDataList = [];
      }
    },
    selectClickIndex(treeObj, index) {
      //搜索节点添加
      let flag = true;
      if (this.dataArrNew.length > 0) {
        for (var i = 0; i < this.dataArrNew.length; i++) {
          if (this.dataArrNew[i].id == treeObj.id) {
            this.$message.error("已经添加过此术语集，请选择其他术语集");
            flag = false;
          }
        }
      }
      if (flag) {
        let nameArr = [];
        this.dataArrNew.push(treeObj);
        this.dataArrNew.forEach(item => {
          nameArr.push(item.twoLayersName);
        });

        this.$set(
          this.AddForm.adverseReactionPhenomenonList[index],
          "terminologyName",
          nameArr.toString()
        );
        this.AddForm.adverseReactionPhenomenonList[
          index
        ].terminologyName = nameArr.toString();
        this.AddForm.adverseReactionPhenomenonList[index].terminologyId =
          treeObj.id;
        this.$set(
          this.AddForm.adverseReactionPhenomenonList[index],
          "terminologyId",
          treeObj.id
        );
      }

      this.$set(
        this.AddForm.adverseReactionPhenomenonList[index],
        "dialogVisible",
        false
      );
      this.searchDataList = [];
    },
    onChange(pageNumber) {
      //分页
      this.paramsList.current = pageNumber;
      this.findConceptByTitleRequest();
    }, 
    treeboxHideIndex(i) {
      for (
        let index = 0;
        index < this.AddForm.adverseReactionPhenomenonList.length;
        index++
      ) {
        this.AddForm.adverseReactionPhenomenonList[index].dialogVisible = false;
      }
      this.findConceptChildrenRequest();
      this.dataArrNew = [];
    },
    treeboxHide() {
      this.dialogVisible = false;

      this.findConceptChildrenRequest();
      this.dataArrNew = [];
    },
    findConceptChildrenRequest(conceptId) {
      let params = {
        current: 1,
        size: 10
      };
      if (conceptId) {
        params.parentId = conceptId;
      }
      getTerminologyTree(params).then(res => {
        if (res.code == 0) {
          let arr = res.data.records.map(item => {
            return {
              ...item,
              total: res.data.total,
              page: res.data.size,
              pages: res.data.pages,
              t: "0"
            };
          });

          this.lists.col = {
            top: 0,
            list: arr
          };
        }
      });
    },
    // 分页
    pagec({ p, list, ps }) {
      this.ld = true;
      // 获取对应页的数据
      getTerminologyTree({
        parentId: list.id,
        type: 1,
        current: p,
        size: 10
      }).then(res => {
        if (res.code == 0) {
          let arr = res.data.records.map(item => {
            return {
              ...item,
              total: res.data.total,
              page: res.data.size,
              pages: res.data.pages,
              t: "0"
            };
          });
          this.ld = false;
          this.$set(list, "list", arr);
          this.$forceUpdate();
        }
      });
    },
    treeitems(list) {
      if (list.item.customers == "0") return;
      this.$set(list.loads, "index", list.index);
      this.$set(list.loads, "type", true);

      let pData = {
        current: 1,
        size: 10,
        parentId: list.item.id
      };

      // 获取数据
      getTerminologyTree(pData).then(res => {
        if (res.code == 0) {
          let arr = res.data.records.map(item => {
            return {
              ...item,
              total: res.data.total,
              page: res.data.size,
              pages: res.data.pages,
              t: "0"
            };
          });
          if (list.item && list.item.openState) {
            this.$set(list.item, "openState", false);
            arr = [];
          } else {
            this.$set(list.item, "openState", true);
          }
          this.$set(list.loads, "type", false);
          this.$set(list.open, list.index, true);
          this.$set(list.item, "list", arr);
          this.$set(list.item, "total", res.data.total);
          this.$set(list.item, "page", res.data.size);
          if (list.item && list.item.openState) {
            this.$set(list.item, "openState", true);
          }
        }
      });
    },
    findConceptByTitleRequest(b, i) {
      if (this.checkForm.terminologyName) {
        this.paramsList.name = this.checkForm.terminologyName;
      } else if (b) {
        this.paramsList.name = this.AddForm.adverseReactionPhenomenonList[
          i
        ].terminologyName;
      }
      getTerminologyTree(this.paramsList).then(res => {
        if (res.code == 0) {
          let { records, total, current } = res.data;
          this.total = total;
          if (records.length > 0) {
            this.searchDataList = records;
          } else {
            this.searchDataList = [];
          }
        }
      });
    },
    rightFunc(item) {
      if (item.eventValue == 1) {
        this.dialogHisRecords = true;
      } else {
        this.dialogAdd = true;
      }
    }
  }
};
</script>
<style>
.el-table tr.setBackground {
  background: #f5f7fa;
}
</style>
<style scoped lang="less">
/deep/.el-drawer__header {
  padding: 0;
  margin: 0;
}

/deep/.el-drawer__body {
  overflow: auto;
}
.adverse-reaction {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.treebox-list {
  width: 100%;
  max-height: 160px;
  overflow: auto;
  background: #fff;

  left: 0;
  top: 32px;
  z-index: 1;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 10px 0;
  .treebox-list-item {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 3px 0 3px 5px;
    line-height: normal;
    .treebox-list-item-title {
      width: 90%;
      line-height: 26px;
      height: 26px;
      padding-right: 10px;
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      border-left: 0;
    }
    .select-btn {
      font-size: 12px;
      color: #1890ff;
      cursor: pointer;
    }
  }
}
.treebox-list-item:hover {
  background-color: #bae7ff;
}
/deep/.el-pagination {
  text-align: right;
  margin-top: 30px;
  margin-right: 30px;
  padding-bottom: 20px;
}

/deep/.el-select {
  width: 100%;
}
.detailsFloat {
  width: 48%;
  float: left;
}
.detailsFloat:nth-child(2) {
  float: right;
}
.hideArrow /deep/.el-icon-arrow-up {
  display: none;
}
.dialogDetailsText li {
  overflow: hidden;
  max-height: 18px;
}
.add-btn-box {
  height: 32px;
  line-height: 32px;
  text-align: center;
  color: #333;
  background: #fcfcfc;
  cursor: pointer;
  border-radius: 3px;
  border: 1px dashed #d9d9d9;
}
</style>
<style >
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.treebox {
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  overflow: hidden;
}
.title {
  padding-left: 10px;
  background-image: linear-gradient(to bottom, #f8f8f8, #ececec);
}
.treeitem {
  padding-left: 10px;
  background: #fff;
  padding: 3px 0 3px 10px;
}
.treeitem:nth-child(odd) {
  background-color: #fff;
}
.icons-down-box {
  width: 15px;
  height: 15px;
  margin-left: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icons-down {
  display: inline-block;
  /* background: url("../../../assets/images/down.png") no-repeat; */
  width: 15px;
  height: 15px;
  transform: rotate(-90deg);
  background-size: 100%;
}
.loading {
  display: inline-block;
  /* background: url("../../../assets/images/loading.png") no-repeat; */
  width: 14px;
  height: 14px;
  background-size: 100%;
  animation: rotaos 1s linear infinite;
}
.iconsright {
  transform: rotate(0deg);
}
@keyframes rotaos {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.rowitem:hover {
  background-color: #bae7ff;
}
.title-ti {
  width: 38px;
  line-height: 26px;
  height: 26px;
  padding-right: 10px;
  text-align: left;
  white-space: nowrap;
  cursor: pointer;
}
.title-ti .title-box {
  width: 90%;
  overflow: hidden;
  border-left: 0;
}
.flex {
  display: flex;
}

.flex-ac {
  align-items: center;
}
.flex-column {
  flex-direction: column;
}
.flex-jc-sb {
  justify-content: space-between;
}
.flex-jc-ac {
  justify-content: center;
  align-items: center;
}
.flex-row {
  flex-direction: row;
}
.flex-jc-sa {
  justify-content: space-around;
}
.flex1 {
  flex: 1;
}
.dataNumText {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff3399;
  line-height: 26px;
  margin-top: 40px !important;
  text-align: left;
}
</style>
